module.exports = __webpack_public_path__ + "static/media/electrician.416f09c3.jpg";